import * as React from "react";

const DoorTypeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#000"
      d="M14.167 2.5a1.667 1.667 0 0 1 1.666 1.667v11.666h.834a.833.833 0 0 1 0 1.667H3.333a.833.833 0 1 1 0-1.667h.834V4.167A1.667 1.667 0 0 1 5.833 2.5zm0 1.667H5.833v11.666h8.334zm-2.084 5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
    ></path>
  </svg>
);

export default DoorTypeIcon;
